import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguageSelectorComponent} from './language-selector/language-selector.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {VerificationCodeInputComponent} from './verification-code-input/verification-code-input.component';
import {TranslateModule} from '@ngx-translate/core';
import {ReCaptchaComponent} from './re-captcha/re-captcha.component';
import {RecaptchaModule} from 'ng-recaptcha';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {PageHeaderComponent} from './page-header/page-header.component';
import {DialogComponent} from './dialog/dialog.component';
import { PaginationComponent } from './pagination/pagination.component';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {PageLayoutComponent} from './@theme/page-layout/page-layout.component';
import {TitleTabComponent} from './@theme/title-tab/title-tab.component';
import {FileDropDirective} from '../core/directives/file-drop.directive';
import { TableNoDataComponent } from './@theme/table-no-data/table-no-data.component';
import {DirectiveModule} from '../directives/directive.module';
import {SidebarComponent} from './@theme/sidebar/sidebar.component';
import { DeleteAlertComponent } from './delete-alert/delete-alert.component';
import { VerticalStepsComponent } from './vertical-steps/vertical-steps.component';

@NgModule({
    declarations: [
        LanguageSelectorComponent,
        VerificationCodeInputComponent,
        SidebarComponent,
        ReCaptchaComponent,
        PageHeaderComponent,
        DialogComponent,
        PaginationComponent,
        FileDropDirective,
        PaginationComponent,
        PageLayoutComponent,
        TitleTabComponent,
        TableNoDataComponent,
        DeleteAlertComponent,
        VerticalStepsComponent
    ],
    exports: [
        LanguageSelectorComponent,
        VerificationCodeInputComponent,
        SidebarComponent,
        ReCaptchaComponent,
        PageHeaderComponent,
        DialogComponent,
        PaginationComponent,
        PageLayoutComponent,
        TitleTabComponent,
        PaginationComponent,
        FileDropDirective,
        TableNoDataComponent,
        DeleteAlertComponent,
        VerticalStepsComponent
    ],
    imports: [
        NgSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        RecaptchaModule,
        TooltipModule,
        NgbPaginationModule,
        CommonModule,
        DirectiveModule,
        FormsModule,
    ]
})
export class ComponentsModule {
}
